import { render, staticRenderFns } from "./ScopeAdd.vue?vue&type=template&id=5cc5b1cf&"
import script from "./ScopeAdd.vue?vue&type=script&lang=js&"
export * from "./ScopeAdd.vue?vue&type=script&lang=js&"
import style0 from "./ScopeAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports